import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WebhookEventStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
  Skipped = 'skipped',
}

export interface WebhookEventAttempt {
  'response-headers': Record<string, string>;
  'response-status': number;
  'response-body': string;
  signature: string;
  'attempted-at-ts': number;
  'created-at': string;
}

export interface WebhookEventAttributes {
  'webhook-url': string;
  status: WebhookEventStatus;
  'event-name': string;
  body: string;
  'result-code': number | null;
  'attempts-left': number;
  attempts: WebhookEventAttempt[];
  'response-time-ms': number | null;
  'next-process-at': string | null;
  'last-attempted-at': string | null;
  'created-at': string;
  'updated-at': string;
}

export interface WebhookEventRelationships {
  event: ApiRelationship<ApiModel.Event>;
  webhook: ApiRelationship<ApiModel.Webhook>;
}

export type WebhookEvent = ApiResource<
  WebhookEventAttributes,
  WebhookEventRelationships,
  ApiModel.WebhookEvent
>;
